import React from 'react';
import AppointmentContext from './AppointmentContext';

export default function useAppointment() {
    return React.useContext(AppointmentContext);;
}
